// Globals
import { useTranslation } from 'react-i18next';
import { CopyOutlined } from '@ant-design/icons';

// Models
import { ILLMTemplateVariable } from '@/models/llmTemplate.model';

// Components
import { Tooltip } from '@/ui';
import { showSuccessToast } from '@/components';
import { StyledChip, StyledChipCopyIcon, StyledChipLabel } from './LLMTemplateVariableItemStyles';

// Helpers
import { useCopyToClipboard } from '@/hooks';

interface ILLMTemplateVariableItemProps {
  variable: ILLMTemplateVariable;
}

const LLMTemplateVariableItem = ({ variable }: ILLMTemplateVariableItemProps) => {
  const { t } = useTranslation();
  const { copy } = useCopyToClipboard();

  const handleCopy = async () => {
    const isCopied = await copy(variable.placeholder);
    if (isCopied) {
      showSuccessToast({ message: t('copied_to_clipboard') });
    }
  };

  return (
    <Tooltip title={variable.description}>
      <StyledChip onClick={handleCopy}>
        <StyledChipLabel>{variable.placeholder}</StyledChipLabel>
        <StyledChipCopyIcon>
          <CopyOutlined />
        </StyledChipCopyIcon>
      </StyledChip>
    </Tooltip>
  );
};

export default LLMTemplateVariableItem;
